import { createConsumer, createSubscriber, getGlobalEventsLogs, IEvent } from '@cian/events-log';
import { ETopic } from '@cian/feedback-form-widget';
import * as React from 'react';

interface IParameters {
  openModal(state: boolean): void;
  onTopicUpdate(topic: ETopic | null): void;
}

export function useEventsLog({ openModal, onTopicUpdate }: IParameters) {
  React.useEffect(() => {
    const feedbackConsumer = createConsumer({ topic: 'feedback-frontend' });
    const feedbackLkConsumer = createConsumer({ topic: 'feedback_lk' });

    const feedbackLkSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'open') {
        onTopicUpdate(event.value);
      }
    });

    const feedbackSubscriber = createSubscriber((event: IEvent<unknown>) => {
      if (event.type === 'open') {
        openModal(true);

        const globalLog = getGlobalEventsLogs();

        globalLog.produce('feedback-frontend', { type: 'popup_opened', value: true });
      }
    });

    feedbackLkConsumer.subscribe(feedbackLkSubscriber);
    feedbackConsumer.subscribe(feedbackSubscriber);

    return () => {
      feedbackConsumer.unsubscribe(feedbackSubscriber);
      feedbackLkConsumer.unsubscribe(feedbackLkSubscriber);
      feedbackConsumer.destroy();
      feedbackLkConsumer.destroy();
    };
  }, [openModal, onTopicUpdate]);
}
